<div
  class="shield-icon-container"
  [ngClass]="{
    'shield-icon-container-home': isIconForHomeScreen,
    'shield-icon-container-meter': !isIconForHomeScreen,
    'shield-icon-container-meter-detail': isIconForDetail
  }"
  matTooltip="{{ getToolTipText() }}"
  [matTooltipShowDelay]="showDelay.value"
  [matTooltipHideDelay]="hideDelay.value"
  [matTooltipPosition]="position.value"
  [matTooltipDisabled]="isIconForMapScreen"
>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 96 96"
    enable-background="new 0 0 96 96"
    xml:space="preserve"
  >
    <g>
      <path
        [ngClass]="{
          'has-active-alarm-shield': isActiveAlarm,
          'has-inactive-alarm-shield': !isActiveAlarm,
          'has-disabled-notification-alarm': !isMeterLicensed
        }"
        d="M87.8,18.1L48,1.3L8.2,18.1c0,0-7.2,50.5,39.8,76.6v0c0,0,0,0,0,0c0,0,0,0,0,0v0
      C95,68.7,87.8,18.1,87.8,18.1z"
      />
      <path
        fill="#FFFFFF"
        d="M79.5,24L48,10.9L16.5,24c0,0-5.8,40,31.4,60.8l0,0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1l0-0.2
      C85.3,64.1,79.5,24,79.5,24z"
      />
      <polygon
        [ngClass]="{
          'has-active-alarm-shield': isActiveAlarm,
          'has-inactive-alarm-shield': !isActiveAlarm,
          'has-disabled-notification-alarm': !isMeterLicensed
        }"
        points="60,26.7 44.5,26.7 39,50.8 46.3,50.9 41.5,68 60,41.7 50.3,41.7 60,26.7"
      />
    </g>
  </svg>

  <div class="counter-container" *ngIf="hasAlarm && badgeVisible">
    {{ alarmCount }}
  </div>
</div>
